import React, { useEffect } from 'react';

import { openObjectiveDetailsPanelActionCreator } from 'actions/objectiveDetailsPanelActions';
import SkeletonLoader from 'components/SkeletonLoader';
import useAsync from 'components/hooks/useAsync';
import useForceUpdate from 'components/hooks/useForceUpdate';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { sendOpenedObjectivePanelEvent } from 'constants/mixpanelHelper';

import { getObjectiveHierarchy } from 'services/objective';

import { Typography13 } from 'uiToolkit/Typography';

import ObjectiveRow from './ObjectiveRow';

const ObjectivesAndKRs = ({ reason = '', disabled = false, goalDetails = {}, updateGoal = () => {} }) => {
  const dispatch = useDispatch();
  const [refreshFlag, forceRefresh] = useForceUpdate();
  const history = useHistory();
  const selectedObjective = goalDetails?.subObjective;

  const { data, run, isIdle, isLoading, isError } = useAsync();

  useEffect(() => {
    if (selectedObjective?.objectiveTimeBoundId) {
      run(getObjectiveHierarchy({ objectiveTimeBoundId: selectedObjective?.objectiveTimeBoundId }));
    }
  }, [selectedObjective?.objectiveTimeBoundId, refreshFlag]);

  const handleOnClick = (otbPostCardId) => {
    dispatch(
      openObjectiveDetailsPanelActionCreator({
        objectivePId: otbPostCardId,
        onNameChange: () => {
          forceRefresh();
        },
        onDelete: () => {
          forceRefresh();
        },
        onLevelChange: () => {
          forceRefresh();
        },
        onReAlign: () => {
          forceRefresh();
        },
      })
    );

    sendOpenedObjectivePanelEvent({
      eventProperties: {
        source: 'KR panel Alignment',
      },
    });
  };

  if (isIdle || isLoading) {
    return <SkeletonLoader skeletons={['100%']} />;
  }

  if (isError) {
    return <Typography13 color="error">Something went wrong. Please try again later.</Typography13>;
  }

  return (
    <ObjectivesContainer>
      {data?.map(({ id: objectiveId, name, objectiveLevel, otbPostCardId }, index) => (
        <ObjectiveRowWrapper key={otbPostCardId} onClick={() => handleOnClick(otbPostCardId)}>
          <ObjectiveRow
            name={name}
            objectiveLevel={objectiveLevel}
            level={data?.length - 1}
            index={index}
            isLast={index === data?.length - 1}
            levelsForWhichLinesToBeDrawn={
              index === data.length - 1 || objectiveLevel === 0 ? [] : [...[], objectiveLevel]
            }
          />
        </ObjectiveRowWrapper>
      ))}
    </ObjectivesContainer>
  );
};

const ObjectiveRowWrapper = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.palette.divider};
`;

const ObjectivesContainer = styled.div`
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.palette.divider};
  margin-top: 1rem;
  margin-bottom: 1.5rem;

  & :last-child {
    border-bottom: none;
  }
`;

export default ObjectivesAndKRs;
